import React from "react";
import { Icon, Grid, Button } from "semantic-ui-react";
import { useIncomingCall } from "./IncomingCallContext";
import DialSessionService from "services/DialSessions";
import styles from "./IncomingCall.module.scss";
import useAuthStore from "stores/useAuthStore";
import useDialerStore from "stores/useDialerStore";
import { useSocket } from "providers/SocketProvider";

function IncomingCall() {
  const {
    isDialogOpen,
    isCalling,
    callInfo,
    toggleMute,
    stopNotification,
    isMinimized,
    setIsMinimized,
    isMuted,
    isAgentOnCall,
  } = useIncomingCall();

  const { socket } = useSocket();

  const acceptCall = async () => {
    const sessionData = {
      name: `Contact (incoming call) - ${new Date().toISOString()}`,
      status: true,
      info: {
        enable_recording: true,
      },
    };

    const dialSession =
      await DialSessionService.createPrivateSession(sessionData);

    // Stored before the window exists so the dialer reads it on mount. Posting
    // it on load instead raced the dialer's listener, and a dropped message
    // left the window rendering the outbound dialer for an inbound call.
    useDialerStore.getState().setIncomingCallInfo({
      dialSessionId: dialSession.id,
      isIncomingCall: true,
      ...callInfo,
    });

    window.open(
      `/dialer/${dialSession.id}?private=1`,
      "_blank",
      "location=yes,height=750,width=1800,scrollbars=yes,status=yes"
    );

    const user = useAuthStore.getState().userAuth;
    if (socket) {
      socket.emit(
        "call_accepted",
        JSON.stringify({
          call_sid: callInfo.call_id,
          agent_id: user.id,
        })
      );
    }
  };

  const declineCall = () => {
    stopNotification();
    const user = useAuthStore.getState().userAuth;
    if (socket) {
      socket.emit(
        "call_declined",
        JSON.stringify({
          call_sid: callInfo.call_id,
          agent_id: user.id,
        })
      );
    }
  };

  const getCallerName = () => {
    switch (callInfo?.contacts_with_phone?.length) {
      case 0:
        return "(No contact)";
      case 1:
        return callInfo.contacts_with_phone[0].name;
      default:
        return "More than one contact found with this phone number";
    }
  };

  if (!isDialogOpen) return null;

  return (
    <React.Fragment>
      <div className={styles["incoming-call"]}>
        <div className={`header ${isCalling ? "calling" : ""}`}>
          <Grid>
            <Grid.Row>
              <Grid.Column
                onClick={() => setIsMinimized(!isMinimized)}
                width={14}
              >
                <p className="title">Inbound Call</p>
              </Grid.Column>
              <Grid.Column width={2} className="actions">
                <Icon
                  name={`bell${isMuted ? " slash" : " "}`}
                  onClick={toggleMute}
                />
                <Icon name="close" onClick={declineCall} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>

        {!isMinimized && (
          <div className="content">
            <div className="display">
              <p className="call-title">Incoming Call...</p>
              <div className="caller">
                <p className="name">{getCallerName()}</p>
                <p className="phone">{callInfo.phone_number}</p>
              </div>

              <div className="actions">
                <Button
                  icon
                  className="accept"
                  onClick={acceptCall}
                  disabled={isAgentOnCall()}
                >
                  <Icon name="call" size="large" inverted />
                </Button>
                <Button icon className="decline" onClick={declineCall}>
                  <Icon name="call" size="large" inverted />
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default IncomingCall;
